import { ChevronDown, ChevronUp } from 'lucide-react';
import {
	NumberField as AriaNumberField,
	type NumberFieldProps as AriaNumberFieldProps,
	Button,
	type ButtonProps,
	composeRenderProps
} from 'react-aria-components';
import { cn } from '../../../components/utils';
import { fieldBorderStyles, FieldGroup } from '../base-controls/FieldGroup';
import { TextInput } from '../base-controls/text-controls/TextInput';
import { FieldLabel } from '../base-controls/FieldLabel';
import { FieldDescription } from '../base-controls/FieldDescription';
import { FieldError } from '../base-controls/FieldError';
import type { BaseFieldProps } from '~/shared/components/types';
import { baseControlStyles } from '../base-controls/util';

export interface NumberFieldProps extends AriaNumberFieldProps, BaseFieldProps {}

export function NumberField({ label, description, hideLabel, ...props }: NumberFieldProps) {
	const { base } = baseControlStyles();
	return (
		<AriaNumberField {...props} className={composeRenderProps(props.className, className => cn('group', base(), className))} aria-label={label}>
			{!hideLabel ? <FieldLabel>{label}</FieldLabel> : null}
			<FieldGroup>
				{renderProps => (
					<>
						<TextInput readOnly={props.isReadOnly} className="border-0 outline-none" />
						<div className={cn(fieldBorderStyles(renderProps), 'flex flex-col border-s-2')}>
							<StepperButton slot="increment">
								<ChevronUp aria-hidden className="size-4" />
							</StepperButton>
							<div className={cn(fieldBorderStyles(renderProps), 'border-b-2')} />
							<StepperButton slot="decrement">
								<ChevronDown aria-hidden className="size-4" />
							</StepperButton>
						</div>
					</>
				)}
			</FieldGroup>
			<FieldDescription>{description}</FieldDescription>
			{props.error && <FieldError {...props.error} />}
		</AriaNumberField>
	);
}

function StepperButton(props: ButtonProps) {
	return (
		<Button
			{...props}
			className="cursor-default px-0.5 text-gray-500 pressed:bg-gray-100 group-disabled:text-gray-200 forced-colors:group-disabled:text-[GrayText]"
		/>
	);
}
